module.exports = __webpack_public_path__ + "static/media/10.8d0bd163.jpg";